import DataTableSearch from "./datatable-search.component";

export default DataTableSearch;
